/** "1–10 of 1,234" style row counts for DataGrid / TablePagination footers */
export function formatPaginationNumber(value: number): string {
  return value.toLocaleString('en-US');
}

export function formatPaginationDisplayedRows({
  from,
  to,
  count,
}: {
  from: number;
  to: number;
  count: number;
}): string {
  if (count === -1) {
    return `${formatPaginationNumber(from)}–${formatPaginationNumber(to)} of more than ${formatPaginationNumber(to)}`;
  }
  return `${formatPaginationNumber(from)}–${formatPaginationNumber(to)} of ${formatPaginationNumber(count)}`;
}
